import {
  ConfigChangeConfigResponse,
  ConfigChangeResponse,
  CustomerConfigResponse,
  CustomerConfigUpdateRequest,
  CustomersApi,
  GetCustomerConfigRequest,
  PlayerDataCustomerConfig,
} from '@Generated/back-office-client/src'
import { BackOfficeDataServiceAPI } from './back-office-data-service'

const getCustomerConfig = async (): Promise<CustomerConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)

  const request: GetCustomerConfigRequest = {
    customerId: BackOfficeDataServiceAPI.getBackOfficeConfig().customerId,
  }

  return await api.getCustomerConfig(request)
}

const patchCustomerConfig = async (
  customerId: string,
  body: CustomerConfigUpdateRequest,
): Promise<CustomerConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.patchCustomerConfig({ customerId, customerConfigUpdateRequest: body })
}

const getPlayerDataConfig = async (customerId: string): Promise<PlayerDataCustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.getPlayerDataConfig({ customerId })
}

const patchPlayerDataConfig = async (
  customerId: string,
  body: PlayerDataCustomerConfig,
): Promise<PlayerDataCustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.patchPlayerDataConfig({
    customerId,
    playerDataCustomerConfig: body,
  })
}

const listCustomerConfigHistory = async (customerId: string): Promise<ConfigChangeResponse[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  const response = await api.listCustomerConfigHistory({ customerId })
  return response.items
}

const getCustomerConfigVersion = async (
  customerId: string,
  changeId: string,
): Promise<ConfigChangeConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.getCustomerConfigVersion({ customerId, changeId })
}

const restoreCustomerConfigVersion = async (
  customerId: string,
  changeId: string,
): Promise<CustomerConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.restoreCustomerConfigVersion({ customerId, changeId })
}

const listPlayerDataConfigHistory = async (customerId: string): Promise<ConfigChangeResponse[]> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  const response = await api.listPlayerDataConfigHistory({ customerId })
  return response.items
}

const getPlayerDataConfigVersion = async (
  customerId: string,
  changeId: string,
): Promise<ConfigChangeConfigResponse> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.getPlayerDataConfigVersion({ customerId, changeId })
}

const restorePlayerDataConfigVersion = async (
  customerId: string,
  changeId: string,
): Promise<PlayerDataCustomerConfig> => {
  const api = BackOfficeDataServiceAPI.getBackOfficeApi(CustomersApi)
  return await api.restorePlayerDataConfigVersion({ customerId, changeId })
}

export const CustomerServiceAPI = {
  getCustomerConfig,
  patchCustomerConfig,
  listCustomerConfigHistory,
  getCustomerConfigVersion,
  restoreCustomerConfigVersion,
  getPlayerDataConfig,
  patchPlayerDataConfig,
  listPlayerDataConfigHistory,
  getPlayerDataConfigVersion,
  restorePlayerDataConfigVersion,
}
